import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({
  custom: {
    palette: { colorSuccess, colorAccentWatermelon },
  },
  palette: { primary },
  spacing: { unit },
}: Theme) =>
  createStyles({
    addIcon: {
      color: colorSuccess,
    },
    buttonsContainer: {
      display: 'inline-flex',
    },
    closeButton: {
      margin: `0px ${unit}px`,
    },
    removeCircleIcon: {
      color: colorAccentWatermelon,
    },
    content: {
      maxHeight: 478,
      overflow: 'auto',
      padding: `${unit * 3}px !important`,
    },
    dayName: {
      color: primary.main,
      display: 'inline-flex',
      flex: 1,
      fontWeight: 600,
      padding: `${unit}px 0px`,
    },
    field: {
      display: 'inline-flex',
      width: 200,
    },
    fieldsDaysRow: {
      display: 'flex',
      flexDirection: 'column',
    },
    fieldsTimesRow: {
      display: 'flex',
      flexDirection: 'column',
    },
    times: {
      display: 'inline-flex',
      paddingLeft: unit * 3,
    },
    to: {
      color: primary.main,
      display: 'flex',
      textAlign: 'center',
      padding: unit * 2,
    },
    hide: {
      visibility: 'hidden',
    },
  });

export default styles;
